import { ArrowLeft } from 'lucide-react'
import { Link, useLocation, useNavigate } from 'react-router'

import { Button } from '@/components/ui/button'

/**
 * Stránka nenalezena. Funguje uvnitř aplikace (catch-all route v AppLayout)
 * i samostatně, nepoužívá kontext hlavičky stránky.
 */
export default function NotFoundPage() {
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const canGoBack = typeof window !== 'undefined' && window.history.length > 1

  return (
    <>
      <title>Stránka nenalezena</title>
      <div className="flex min-h-[60vh] w-full items-center justify-center px-4 py-16">
        <div className="w-full max-w-md text-center">
          <p className="text-xs font-medium tracking-[0.04em] text-muted-foreground uppercase tabular">Chyba 404</p>
          <h1 className="mt-3 text-2xl font-medium tracking-[-0.02em] text-balance">Tuhle stránku jsme nenašli</h1>
          <p className="mt-2 text-sm text-muted-foreground text-pretty">
            Odkaz je možná zastaralý, nebo se stránka přesunula. Zkontrolujte adresu, případně pokračujte na přehled.
          </p>
          {pathname !== '/404' && (
            <p className="mx-auto mt-4 w-fit max-w-full truncate rounded-md border bg-muted px-2 py-1 font-mono text-xs text-muted-foreground">
              {pathname}
            </p>
          )}
          <div className="mt-6 flex flex-wrap items-center justify-center gap-2">
            {canGoBack && (
              <Button variant="outline" onClick={() => navigate(-1)}>
                <ArrowLeft />
                Zpět
              </Button>
            )}
            <Button asChild>
              <Link to="/">Na přehled</Link>
            </Button>
          </div>
        </div>
      </div>
    </>
  )
}
